module.exports = __webpack_public_path__ + "img/13.e8920d42.jpg";